import { render, staticRenderFns } from "./examForm.vue?vue&type=template&id=6847b442&"
import script from "./examForm.vue?vue&type=script&lang=js&"
export * from "./examForm.vue?vue&type=script&lang=js&"
import style0 from "./examForm.vue?vue&type=style&index=0&id=6847b442&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports